import React, { EventHandler } from 'react';
import { TestResultDc } from '@ecosconnect/core/src/types/jobFormData';
import PropTypes from 'prop-types';
import { Input } from '../../../Form';
import AccordionItem from '../../../Accordion/AccordionItem';

type DcTestResultEditProps = {
  test: TestResultDc;
  onFormInputChange: EventHandler<any>;
};

const DcTestResultEdit: React.FC<DcTestResultEditProps> = ({
  test,
  onFormInputChange,
}) => {
  return (
    <>
      <AccordionItem
        label="Check 1"
        alignItems="center"
        as="label"
        value={
          <Input
            onChange={onFormInputChange}
            required
            variant="accordion"
            type="number"
            name="check1"
            value={test.check1}
            step="0.1"
            min="0"
            max="200"
            autoComplete="off"
          />
        }
      />
      <AccordionItem
        label="Check 2"
        alignItems="center"
        as="label"
        value={
          <Input
            onChange={onFormInputChange}
            required
            variant="accordion"
            type="number"
            name="check2"
            value={test.check2}
            step="0.1"
            min="0"
            max="200"
            autoComplete="off"
          />
        }
      />
    </>
  );
};

DcTestResultEdit.propTypes = {
  test: PropTypes.any.isRequired,
};

export default DcTestResultEdit;
